"use strict";
/**
 * UI Utilities
 * Shared utility functions for UI components
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setButtonLoading = setButtonLoading;
/**
 * Set button loading state
 */
function setButtonLoading(buttonId, isLoading) {
    const button = document.getElementById(buttonId);
    if (button) {
        button.disabled = isLoading;
        button.textContent = isLoading
            ? "Loading..."
            : button.dataset.originalText || button.textContent || "";
    }
}
